module.exports = __webpack_public_path__ + "static/media/drag-drop.4f3c1aa5.svg";